import styled from '@emotion/styled';
import Link from 'next/link';

const StyledLink = styled(Link)(
  {
    textDecoration: 'none',
    lineHeight: '21px'
  },
  ({ theme }) => ({
    'color': theme.palette.colors.lightPeriwinkle,
    '&:hover': {
      color: theme.palette.colors.white
    }
  })
);

export default StyledLink;
